import { render, staticRenderFns } from "./ProductScrapReasonList.vue?vue&type=template&id=0e1fa52d"
import script from "./ProductScrapReasonList.vue?vue&type=script&lang=ts"
export * from "./ProductScrapReasonList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports